import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PurchaseApplyApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'purchaseApply'
  }

}